import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { LoginScreen } from './components/auth/LoginScreen';
import { Shell } from './components/shell/Shell';
import { AuthProvider, useAuth } from './lib/auth';
import { Parceiros } from './pages/Parceiros';
import { PartnerDetail } from './pages/PartnerDetail';
import { Saude } from './pages/Saude';
import { VisaoGeral } from './pages/VisaoGeral';

function Gate() {
  const { status } = useAuth();

  if (status !== 'logged_in') return <LoginScreen />;

  return (
    <Routes>
      <Route element={<Shell />}>
        <Route index element={<VisaoGeral />} />
        <Route path="parceiros" element={<Parceiros />} />
        <Route path="parceiros/:id" element={<PartnerDetail />} />
        <Route path="saude" element={<Saude />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Gate />
      </AuthProvider>
    </BrowserRouter>
  );
}
